module.exports = __webpack_public_path__ + "static/media/Referencias_de_Boas_Praticas.b07a77fc.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/docs/Referencias_de_Boas_Praticas.pdf
// module id = 414
// module chunks = 0